export default __webpack_public_path__ + "static/media/basic-detail-icon.2bc2dac3.svg";